<template>
  <div class="content-main">

    <div class="coupon-container">
      <div class="platform-title">淘宝外卖 X 饿了么</div>
      <div class="coupon-cards flex-box">
        <div class="coupon-card">
          <div class="coupon-header"><span class="coupon-tag">外卖</span></div>
          <div class="coupon-body">
            <div class="coupon-amount"><span class="currency">¥</span><span class="amount">11</span></div>
            <div class="coupon-threshold">满15元可用</div>
          </div>
          <div class="coupon-footer"><div class="coupon-type">淘宝外卖红包</div></div>
        </div>

        <div class="coupon-card">
          <div class="coupon-header"><span class="coupon-tag">外卖</span></div>
          <div class="coupon-body">
            <div class="coupon-amount"><span class="currency">¥</span><span class="amount">15</span></div>
            <div class="coupon-threshold">满30元可用</div>
          </div>
          <div class="coupon-footer"><div class="coupon-type">淘宝外卖红包</div></div>
        </div>
      </div>

    </div>

    <div class="receive-progress">——• 领取流程 •——</div>

    <div class="steps flex-box">
      <div class="step">
        <div class="step-title">步骤一</div>
        <div class="step-content">点击下方按钮复制红包口令</div>
      </div>
      <div class="step">
        <div class="step-title">步骤二</div>
        <div class="step-content">打开『淘宝』APP</div>
      </div>
      <div class="step">
        <div class="step-title">步骤三</div>
        <div class="step-content">领取外卖红包</div>
      </div>
    </div>

    <div class="expand-box">
      <button class="expand-btn animate__pulse"
      v-clipboard:copy="elePassword"
      v-clipboard:success="copyCoupon"
      v-clipboard:error="copyError">点击立即领取</button>
    </div>

  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast } from 'vant'

export default{
  data(){
    return {
      // elePassword: '0復制此段 666:/＄eT4wTRE＄~.👉饿了么App👈【打开饿了么APP 扫红包】'
      // elePassword: '【密令简版】￥O6z9V5qp0qL￥/ HU7405'
      elePassword: '【淘口令】￥bibCfGiKwh8￥/ HU7405'
    }
  },
  methods: {
    copyCoupon(){
      // console.log('success')
      Toast('复制成功，打开【淘宝App】领取')
    },
    copyError(){
      Toast('复制失败，请重试')
    }
  },
  mounted(){
    // this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{
  width:100%;
  min-height:100vh;
  /* background: linear-gradient(to bottom right, #e6f5ff, #ffe6ee); */
  /* background: linear-gradient(to bottom right, #ffe6ee, #e6f5ff); */
  background: #ffe6ee;
  /* background-size:100vw auto; */
  padding:20px;
}

.coupon-container{
  /* background: linear-gradient(135deg, #ff7e87 0%, #ff9248 100%); */
  background: linear-gradient(135deg, #ffece6, #ffd4d4);
  border-radius: 24px;
  padding: 50px 24px;
  box-shadow: 0 10px 30px rgba(255, 126, 135, 0.3);
  margin-top:50px;
  margin-bottom:50px;
}

.platform-title{
  font-size:48px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom:34px;
}

.coupon-cards{
  justify-content: space-around;
}
.coupon-card {
  /* flex: 1; */
  background: linear-gradient(180deg, #ffffff 0%, #fff1f3 100%);
  border-radius: 18px;
  /* overflow: hidden;
  display: flex;
  flex-direction: column; */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  /* transition: all 0.3s ease; */
  width:45%;
}
.coupon-card .coupon-header {
  padding: 8px 12px;
  position: relative;
  height: 48px;
  display: flex;
}
.coupon-card .coupon-tag {
  background-color: #FF5976;
  color: white;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: bold;
}
.coupon-card .coupon-body {
  padding: 12px 16px;
  text-align: center;
}
.coupon-card .coupon-amount {
  color: #FF5976;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.coupon-card .currency {
  font-size: 26px;
  margin-right: 2px;
}
.coupon-card .amount {
  font-size: 54px;
  line-height: 1;
}
.coupon-card .coupon-threshold {
  font-size: 20px;
  color: #666;
  margin-top: 8px;
}
.coupon-card .coupon-footer {
  margin-top: auto;
  background: linear-gradient(135deg, #FF5976 0%, #FF7B6B 100%);
  padding: 10px;
  text-align: center;
  border-bottom-left-radius:18px;
  border-bottom-right-radius:18px;
}
.coupon-card .coupon-type {
  color: white;
  font-size: 20px;
  font-weight: bold;
}

.receive-progress{
  color:#fff;
  font-size:48px;
  font-weight:700;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.steps{
  background:#fff;
  border-radius: 18px;
  color: #ff71a2;
  font-size:24px;
  justify-content:space-around;
  padding:20px;
  margin-top:20px;
  margin-bottom:40px;
}
.steps .step{
  width:30%;
  height:125px;
  border:1px dashed #ff71a2;
  border-radius:10px;
  padding:10px;
}

.steps .step .step-content{
  font-size:26px;
  font-weight:bold;
}

.expand-box{
  position: absolute;
  left: 0;
  right: 0;
  /* margin: 0 4.26667vw; */
  /* top: 138.66667vw; */
}
.expand-btn{
  display: block;
  width: 78.66667vw;
  height: 10.66667vw;
  margin: 0 auto;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-duration: .8s;
  animation-duration: .8s;
  /* background-image: linear-gradient(90deg,#f5ce56,#e47603); */
  background: linear-gradient(to right, #ff71a2, #ff8f4c);
  border-radius: 61.5px;
  color: #fff;
  font-weight: 700;
  font-size: 4.13333vw;
  box-shadow: none;
  outline: none;
  border: none;
}
.animate__pulse{
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

@keyframes pulse {
  0% {
      transform: scaleX(1);
  }
  50% {
      transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
      transform: scaleX(1);
  }
}
</style>
